import { type PaletteOptions } from '@mui/material/styles'
import { additional } from './light-additional'
import { blue } from './light-blue'
import { green } from './light-green'
import { grey } from './light-grey'
import { opacity } from './light-opacity'
import { pure } from './light-pure'
import { dhlRed } from './light-dhl-red'

export const components: PaletteOptions['components'] = {
  avatar: {
    backgroundBlue: additional.vibrandBlue,
    border: grey[400],
  },
  backdrop: {
    fill: opacity.dark[600],
  },
  bottomNavigation: {
    contrast: dhlRed[600],
  },
  buttonLink: {
    hover: grey[600],
  },
  chip: {
    icon: opacity.dark[400],
    focus: grey[900],
    border: grey[400],
    hover: opacity.dark[150],
  },
  dataGrid: {
    zebraDark: grey[200],
    hover: opacity.dark[100],
  },
  divider: {
    line: grey[300],
  },
  input: {
    background: pure.light,
  },
  link: {
    contrast: dhlRed[600],
  },
  navbar: {
    selected: opacity.primary[100],
    selectedHover: opacity.primary[150],
    contrast: pure.light, // dhlRed[600] ?
  },
  pageHeader: {
    default: dhlRed[600],
    accept: green[600],
    test: blue[600],
    color: {
      contrast: pure.dark,
      default: pure.light,
    },
  },
  switch: {
    fill: grey[300],
    hover: opacity.dark[50],
    focus: opacity.dark[80],
    border: grey[400],
    knobDisabled: grey[300],
  },
  tab: {
    selected: dhlRed[600],
  },
}
